import { getSiteMap } from '@gik/api/legal';
import type { FallbackProps, StaticProps } from '@gik/core/api/BaseAPIConfig';
import { ISRRevalidateTimeout, baseFallback } from '@gik/core/api/BaseAPIConfig';
import { PageHeadKeys } from '@gik/core/hocs/PageHeadKeys';
import { withTitle } from '@gik/core/hocs/withTitle';
import { GiveSitemapPage } from '@gik/core/pages/GiveSitemap';
import { catchSSRError } from '@gik/core/utils/catchSSRError';
import { measureSSRPerformance } from '@gik/core/utils/measureSSRPerformance';
import Head from '@/components/Head';
import type { PageLayoutProps } from '@/components/layout/PageLayout';
import { SWRConfig } from 'swr';

export default function GiveSitemapPageComp({ fallback }: FallbackProps<unknown[]>) {
  // Pass the static data as a prop for SSR/SSG
  // Guard `fallback` before `Object.keys` — optional chaining alone doesn't help
  // because `Object.keys(fallback)` is evaluated regardless and throws on null.
  const sitePagesData = fallback ? fallback[Object.keys(fallback)[0]] : undefined;
  return withTitle(
    'Give By Sitemap',
    <SWRConfig value={{ fallback }}>
      <Head>
        <meta name="robots" key={PageHeadKeys.META_ROBOTS} content="index,follow" />
      </Head>
      <GiveSitemapPage sitePagesData={sitePagesData} />
    </SWRConfig>
  );
}

GiveSitemapPageComp.getLayout = function getLayout(page, _layoutProps: PageLayoutProps) {
  return <div>{page}</div>;
};

async function _getStaticProps(): Promise<StaticProps<string[]>> {
  const siteMap = getSiteMap();
  const json = await siteMap.json;
  return baseFallback({ [siteMap.key]: json }, undefined, ISRRevalidateTimeout.sitemapSlow);
}

export const getStaticProps = catchSSRError(measureSSRPerformance(_getStaticProps));
